




























































import { defineComponent, ref, PropType, computed } from '@vue/composition-api';
import VirtualList from 'vue-virtual-scroll-list';
import SelectNoDataIcon from '@tt4b/ttam-assets/src/svgs/select-no-data.svg';
import AppItem from './app-item.vue';
import OperationList from '@/components/common/operation-list/index.vue';
import DropdownPanel from '@/components/common/dropdown-panel/index.vue';
import SelectListOperator from '@/components/common/select-list-operator/index.vue';
import { AppDataItem } from '../../types';
import { i18n } from './../../../../../i18n';

const name = 'ttam-app-events-app-select';
export default defineComponent({
  name,
  components: { VirtualList, SelectNoDataIcon, OperationList, DropdownPanel, SelectListOperator },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String as PropType<string>,
      default: i18n.t('common_app_select_placeholder'),
    },
    dataSource: {
      type: Array as PropType<AppDataItem[]>,
      default: () => [],
    },
    value: {
      type: String as PropType<string>,
      default: '',
    },
    addUrl: {
      type: String as PropType<string>,
      default: '',
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    isInnerOperation: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const popperVisible = ref(false);
    const inputRef = ref(null);
    const currentItem = computed<AppDataItem>(
      () => props.dataSource.find(i => i?.Id === props.value) ?? ({} as AppDataItem),
    );

    const onFocus = () => {
      if (props.disabled) {
        return;
      }
      emit('focus');
      popperVisible.value = true;
    };
    const onClick = (i: AppDataItem) => {
      popperVisible.value = false;
      emit('change', i);
      emit('input', i.Id);
    };
    const onClose = () => {
      popperVisible.value = false;
    };
    const onRefresh = () => {
      emit('refresh');
      inputRef.value?.focus?.();
    };

    const onCreate = () => {
      emit('create');
      window.open(props.addUrl, '_blank');
    };
    const isClearStatus = ref(false);
    const onShow = () => {
      if (isClearStatus.value) {
        popperVisible.value = false;
        if (inputRef.value && inputRef.value?.blur) {
          inputRef.value?.blur();
        }
        setTimeout(() => {
          isClearStatus.value = false;
        }, 300);
        return;
      }

      emit('open');
    };

    const onClear = () => {
      if (props.disabled) {
        return;
      }
      isClearStatus.value = true;
      emit('clear');
    };

    const appName = computed(() => currentItem.value?.name ?? '');
    const isShowAdd = computed(() => Boolean(props.addUrl));

    const operationList = computed(() =>
      isShowAdd.value
        ? [
            {
              icon: 'vi-icon2-refresh',
              click: onRefresh,
              disabled: props.disabled,
              hint: i18n.t('adgroup_convert-refresh'),
            },
            {
              icon: 'vi-icon2-add',
              click: onCreate,
              disabled: props.disabled,
            },
          ]
        : [
            {
              icon: 'vi-icon2-refresh',
              click: onRefresh,
              disabled: props.disabled,
              hint: i18n.t('adgroup_convert-refresh'),
            },
          ],
    );

    return {
      name,
      inputRef,
      appName,
      currentItem,
      operationList,
      isShowAdd,
      popperVisible,
      isClearStatus,
      AppItem,
      onFocus,
      onClick,
      onClose,
      onRefresh,
      onCreate,
      onClear,
      onShow,
    };
  },
});
